import { unitTypesWithoutDetails } from '@shared/models/consts';
import { fromUnitType, IntuitiveIndication } from './intuitive-indication';

export const TOOTH_EDITOR_TOOTH_NUMBER_SEPARATOR = ',';

export const indicationsWithoutDetails: readonly (IntuitiveIndication | undefined | null)[] = [
	...unitTypesWithoutDetails.map(u => fromUnitType(u)),
	IntuitiveIndication.BridgeMissing,
	IntuitiveIndication.Bridge
];

export const BRIDGE_VALIDATION_ERRORS = {
	invalidSpanWarning: 'TeethDiagram.BridgeValidationInvalidSpanWarning',
	regularWarning: 'TeethDiagram.BridgeValidationRegularWarning'
} as const;
